'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);
  return { ref, inView };
}

const leftItems = [
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1a2f5149d-1785328106522.png",
  title: 'Excellence Médicale',
  desc: 'Des standards élevés de soins médicaux conformes aux meilleures pratiques internationales.'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1db721858-1784717021312.png",
  title: 'Soins Personnalisés',
  desc: 'Une approche centrée sur le patient pour répondre aux besoins spécifiques de chaque individu.'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1a0992a75-1773820909451.png",
  title: 'Assurances & Mutuelles',
  desc: 'Partenariats avec les principales compagnies d\'assurance : AXA, NSIA, SUNU, AMSA et bien d\'autres.'
}];


const rightItems = [
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_18e674b53-1785328106040.png",
  title: 'Médecine de Proximité',
  desc: 'Diagnostics réalisés directement au domicile des patients, sur demande, pour plus de confort.'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1df9fb64e-1785328106817.png",
  title: 'Innovation Technologique',
  desc: 'Intégration des dernières technologies médicales, dont une unité mobile de radiologie numérique.'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_18f5403e5-1785328106945.png",
  title: 'Responsabilité Sociale',
  desc: 'Engagement envers les enfants dans le besoin : services de santé aux orphelinats et ONG.'
}];


export default function WhyChooseUs() {
  const { ref, inView } = useInView();

  return (
    <div className="why-choose-us">
      <div className="dentaire-container">
        {/* Section Title */}
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: 0 }}>
              <h3>pourquoi nous choisir</h3>
              <h2><span>Les Valeurs</span> qui Nous Distinguent</h2>
              <p>COSA s'engage à offrir une expérience médicale alliant excellence, accessibilité et esthétisme.</p>
            </div>
          </div>
        </div>

        <div className="row" ref={ref}>
          {/* Left Items */}
          <div className="col-lg-4 col-md-6">
            <div className="why-choose-box-1">
              {leftItems?.map((item, i) =>
              <div
                key={item?.title}
                className="why-choose-item"
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'translateY(0)' : 'translateY(30px)',
                  transition: `opacity 0.6s ease ${i * 0.25}s, transform 0.6s ease ${i * 0.25}s`
                }}>
                
                  <div className="icon-box">
                    <img src={item?.icon} alt={item?.title} />
                  </div>
                  <div className="why-choose-content">
                    <h3>{item?.title}</h3>
                    <p>{item?.desc}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Center Image */}
          <div className="col-lg-4">
            <div
              className="why-choose-image"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s'
              }}>
              
              <figure>
                <img
                  src="/assets/images/why-choose-us-img.png"
                  alt="Centre médical COSA Ananeraie"
                  style={{ width: '100%' }} />
                
              </figure>
            </div>
          </div>

          {/* Right Items */}
          <div className="col-lg-4 col-md-6">
            <div className="why-choose-box-2">
              {rightItems?.map((item, i) =>
              <div
                key={item?.title}
                className="why-choose-item"
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'translateY(0)' : 'translateY(30px)',
                  transition: `opacity 0.6s ease ${i * 0.25}s, transform 0.6s ease ${i * 0.25}s`
                }}>
                
                  <div className="icon-box">
                    <img src={item?.icon} alt={item?.title} />
                  </div>
                  <div className="why-choose-content">
                    <h3>{item?.title}</h3>
                    <p>{item?.desc}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Star Icon */}
      <div className="icon-star-image">
        <img src="https://html.awaikenthemes.com/dentaire/images/icon-star.svg" alt="Star decoration" />
      </div>
    </div>);

}